<script>
import Spins from '../resources/spins.svg';
export default Spins;
</script>
